/** Account settings tabs as they appear in the URL (`?tab=`), indexed by page number. */
export const ACCOUNT_TABS = [
  'details',
  'subscription',
  'billing',
  'payment-providers',
  'taxes',
  'waivers',
  'integrations',
  'api-access',
  'website-plugin',
] as const

/** Older deep links from elsewhere in the app (`?origin=`), still honoured. */
const ORIGIN_PAGES: Record<string, number> = {
  subscription: 1,
  payment_provider: 3,
  taxes: 4,
  waiver: 5,
  api_access: 7,
  website_plugin: 8,
}

const PAYMENT_PROVIDERS_PAGE = 3

/** The page the URL asks for: `?tab=`, then a legacy `?origin=`, else Details. */
export const accountPageFromSearch = (search: string): number => {
  const params = new URLSearchParams(search)
  const tabPage = (ACCOUNT_TABS as readonly string[]).indexOf(
    params.get('tab') ?? ''
  )
  if (tabPage >= 0) {
    return tabPage
  }

  const origin = params.get('origin') ?? ''
  if (origin.includes('onboarding')) {
    return PAYMENT_PROVIDERS_PAGE
  }
  return ORIGIN_PAGES[origin] ?? 0
}

/** The query string for a page; one-off params such as `origin` are dropped. */
export const accountPageSearch = (page: number): string =>
  `?tab=${ACCOUNT_TABS[page] ?? ACCOUNT_TABS[0]}`
